/* QGC Trade: predictive header search + filter panel helpers + header-state -> State filter sync */
(function(){
  /* ---------- predictive search ---------- */
  var form = document.getElementById('hdrSearch');
  var input = document.getElementById('hdrSearchInput');
  var box = document.getElementById('hdrSuggest');
  if(form && input && box){
    var timer = null, lastQ = '', ctrl = null, activeIdx = -1;
    var FIELDS = 'title,product_type,variants.title,vendor,tag';
    function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function hi(text, q){
      var t = esc(text); if(!q) return t;
      var words = q.trim().split(/\s+/).filter(Boolean).map(function(w){ return w.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'); });
      if(!words.length) return t;
      return t.replace(new RegExp('(' + words.join('|') + ')', 'ig'), '<mark>$1</mark>');
    }
    function searchUrl(q){ return withState(form.getAttribute('action') + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q)); }
    function items(){ return Array.prototype.slice.call(box.querySelectorAll('a.hs-item, a.hs-all')); }
    function setActive(i){
      var list = items(); activeIdx = i;
      list.forEach(function(a, n){ a.classList.toggle('is-active', n === i); });
      if(list[i]) list[i].scrollIntoView({block:'nearest'});
    }
    function close(){ box.hidden = true; box.innerHTML = ''; activeIdx = -1; input.setAttribute('aria-expanded','false'); }
    function render(q, data){
      var r = (data && data.resources && data.resources.results) || {};
      var prods = r.products || [], cols = r.collections || [], qs = r.queries || [];
      var h = '';
      if(qs.length){
        h += '<div class="hs-group"><div class="hs-label">Suggestions</div>' + qs.slice(0,4).map(function(s){
          return '<a class="hs-item" href="' + searchUrl(s.text) + '"><span class="hs-t">' + (s.styled_text || esc(s.text)) + '</span></a>';
        }).join('') + '</div>';
      }
      if(cols.length){
        h += '<div class="hs-group"><div class="hs-label">Categories</div>' + cols.slice(0,3).map(function(c){
          return '<a class="hs-item" href="' + esc(withState(c.url)) + '"><span class="hs-t">' + hi(c.title, q) + '</span></a>';
        }).join('') + '</div>';
      }
      if(prods.length){
        h += '<div class="hs-group"><div class="hs-label">Products</div>' + prods.slice(0,6).map(function(p){
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          if(img && img.indexOf('?') === -1) img += '?width=120';
          return '<a class="hs-item" href="' + esc(p.url) + '">'
            + '<span class="hs-thumb" style="background-image:url(\'' + esc(img) + '\')"></span>'
            + '<span><span class="hs-t">' + hi(p.title, q) + '</span>'
            + (p.type ? '<br><span class="hs-sub">' + esc(p.type) + '</span>' : '') + '</span></a>';
        }).join('') + '</div>';
      }
      if(!prods.length && !cols.length){
        h += '<div class="hs-empty">No quick matches for “' + esc(q) + '”. Press Enter to search the full range.</div>';
      }
      h += '<a class="hs-all" href="' + searchUrl(q) + '">See all results for “' + esc(q) + '” →</a>';
      box.innerHTML = h; box.hidden = false; activeIdx = -1; input.setAttribute('aria-expanded','true');
    }
    function fetchSuggest(q){
      if(ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection,query&resources[limit]=6'
        + '&resources[options][unavailable_products]=last&resources[options][fields]=' + FIELDS;
      fetch(url, {credentials:'same-origin', signal: ctrl ? ctrl.signal : undefined})
        .then(function(r){ return r.json(); })
        .then(function(d){ if(input.value.trim() === q) render(q, d); })
        .catch(function(){});
    }
    input.addEventListener('input', function(){
      var q = input.value.trim();
      clearTimeout(timer);
      if(q.length < 2){ close(); lastQ = ''; return; }
      if(q === lastQ) return;
      timer = setTimeout(function(){ lastQ = q; fetchSuggest(q); }, 180);
    });
    input.addEventListener('keydown', function(e){
      var list = items();
      if(box.hidden || !list.length){ if(e.key === 'Escape') close(); return; }
      if(e.key === 'ArrowDown'){ e.preventDefault(); setActive(activeIdx + 1 >= list.length ? 0 : activeIdx + 1); }
      else if(e.key === 'ArrowUp'){ e.preventDefault(); setActive(activeIdx - 1 < 0 ? list.length - 1 : activeIdx - 1); }
      else if(e.key === 'Enter' && activeIdx > -1){ e.preventDefault(); window.location.href = list[activeIdx].href; }
      else if(e.key === 'Escape'){ close(); }
    });
    input.addEventListener('focus', function(){ if(box.innerHTML && input.value.trim().length >= 2){ box.hidden = false; } });
    document.addEventListener('click', function(e){ if(!form.contains(e.target)) { box.hidden = true; } });
    form.addEventListener('submit', function(e){
      if(!input.value.trim()){ e.preventDefault(); input.focus(); return; }
      /* carry the header state into the search results */
      if(!form.querySelector('input[name="' + PARAM + '"]')){
        stateList().forEach(function(st){ var h = document.createElement('input'); h.type = 'hidden'; h.name = PARAM; h.value = st; form.appendChild(h); });
      }
    });
  }

  /* ---------- filter panel: mobile open/close + sort ---------- */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-tf-open]');
    if(t){ var p = document.getElementById('tfPanel'); if(p){ p.classList.add('open'); document.body.style.overflow = 'hidden'; } return; }
    if(e.target.closest('[data-tf-close]')){ var p2 = document.getElementById('tfPanel'); if(p2){ p2.classList.remove('open'); document.body.style.overflow = ''; } }
    if(e.target.closest('[data-tf-change-state]')){ e.preventDefault(); var b = document.getElementById('stateSelectBtn'); if(b){ window.scrollTo({top:0, behavior:'smooth'}); setTimeout(function(){ b.click(); }, 250); } }
  });
  var sortSel = document.getElementById('tfSort');
  if(sortSel){
    sortSel.addEventListener('change', function(){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortSel.value);
      u.searchParams.delete('page');
      window.location.href = u.pathname + u.search;
    });
  }
})();

/* ---------- Header state = State filter (spec 1.1) ----------
   The state chosen in the header is applied to Shopify's own filtering as
   filter.p.m.custom.trade_states=<STATE>, so every result and filter count is accurate for that state.
   - Collection & search pages: if the URL doesn't match the header state, reload with it (replace, no history entry).
   - Links to collections/search are rewritten to carry the state, so pages normally load already filtered.
   - Changing state in the header re-applies it. WA/NT (not serviced) are left unfiltered; the grid shows the
     "we don't ship there" notice instead.
   - "All states" adds every serviced state (NSW, QLD, VIC, SA, TAS, ACT); Shopify treats them as OR, so results are
     everything stocked in at least one state. */
var PARAM = 'filter.p.m.custom.trade_states';
var SHIPPED = ['NSW','QLD','VIC','SA','TAS','ACT'];
function stateList(){
  var s = ''; try{ s = localStorage.getItem('qgc_trade_state') || ''; }catch(e){}
  if(s === 'ALL') return SHIPPED.slice(); /* All states: products stocked in any serviced state */
  return SHIPPED.indexOf(s) !== -1 ? [s] : [];
}
function shippedState(){ var l = stateList(); return l.length === 1 ? l[0] : ''; }
function withState(href){
  var list = stateList();
  if(!list.length || !href) return href;
  try{
    var u = new URL(href, window.location.origin);
    if(u.origin !== window.location.origin) return href;
    var p = u.pathname;
    var listing = (p.indexOf('/collections/') === 0 && p.indexOf('/products/') === -1) || p === '/search';
    if(!listing) return href;
    u.searchParams.delete(PARAM);
    list.forEach(function(st){ u.searchParams.append(PARAM, st); });
    return u.pathname + u.search + u.hash;
  }catch(e){ return href; }
}
(function(){
  function isListingPage(){ return !!document.getElementById('tfPanel'); }
  function syncUrl(){
    if(!isListingPage()) return;
    var list = stateList();
    var u = new URL(window.location.href);
    var cur = u.searchParams.getAll(PARAM);
    if(list.length){
      if(cur.length === list.length && cur.slice().sort().join(',') === list.slice().sort().join(',')) return;
      u.searchParams.delete(PARAM); list.forEach(function(st){ u.searchParams.append(PARAM, st); }); u.searchParams.delete('page');
      window.location.replace(u.pathname + u.search + u.hash);
    } else if(cur.length){
      u.searchParams.delete(PARAM); u.searchParams.delete('page');
      window.location.replace(u.pathname + u.search + u.hash);
    }
  }
  function rewriteLinks(){
    if(!stateList().length) return;
    document.querySelectorAll('a[href]').forEach(function(a){
      var h = a.getAttribute('href');
      if(!h || h.charAt(0) === '#' || h.indexOf('mailto:') === 0 || h.indexOf('tel:') === 0) return;
      var n = withState(h);
      if(n !== h) a.setAttribute('href', n);
    });
  }
  syncUrl();
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rewriteLinks); else rewriteLinks();
  document.addEventListener('qgc:stateChanged', function(){ syncUrl(); rewriteLinks(); });
})();
